import { createSelector } from 'reselect'
// import { List } from 'immutable'
const leaveEntitlementSelector = state => state.get('leaveEntitlement')

export const getIsFetching = createSelector(
  leaveEntitlementSelector,
  leaveEntitlementImmutable => {
    const leaveEntitlement = leaveEntitlementImmutable.toJS()
    return leaveEntitlement.leaveEntitlementList.isFetching
    || leaveEntitlement.leaveEntitlementGet.isFetching
    || leaveEntitlement.leaveEntitlementEdit.isFetching
    || leaveEntitlement.leaveEntitlementCreate.isFetching
    || leaveEntitlement.leaveEntitlementDelete.isFetching
  }
)
export const getLeaveEntitlementData = createSelector(
  leaveEntitlementSelector,
  leaveEntitlementImmutable => {
    const leaveEntitlement = leaveEntitlementImmutable.toJS()
    return leaveEntitlement.leaveEntitlementList.leaveEntitlements
  }
)
export const getLeaveEntitlementByIDData = createSelector(
  leaveEntitlementSelector,
  leaveEntitlementImmutable => {
    const leaveEntitlement = leaveEntitlementImmutable.toJS()
    return leaveEntitlement.leaveEntitlementGet.leaveEntitlement
  }
)
export const editLeaveEntitlementData = createSelector(
  leaveEntitlementSelector,
  leaveEntitlementImmutable => {
    const leaveEntitlement = leaveEntitlementImmutable.toJS()
    return leaveEntitlement.leaveEntitlementEdit
  }
)
export const createLeaveEntitlementData = createSelector(
  leaveEntitlementSelector,
  leaveEntitlementImmutable => {
    const leaveEntitlement = leaveEntitlementImmutable.toJS()
    return leaveEntitlement.leaveEntitlementCreate
  }
)
export const deleteLeaveEntitlementData = createSelector(
  leaveEntitlementSelector,
  leaveEntitlementImmutable => {
    const leaveEntitlement = leaveEntitlementImmutable.toJS()
    return leaveEntitlement.leaveEntitlementDelete.deletedLeaveEntitlement
  }
)
export const redirectEntitlement = createSelector(
  leaveEntitlementSelector,
  leaveEntitlementImmutable => {
    const leaveEntitlement = leaveEntitlementImmutable.toJS()
    return ({
      redirect: (leaveEntitlement.leaveEntitlementList.redirect
      || leaveEntitlement.leaveEntitlementGet.redirect
      || leaveEntitlement.leaveEntitlementEdit.redirect
      || leaveEntitlement.leaveEntitlementCreate.redirect
      || leaveEntitlement.leaveEntitlementDelete.redirect),
      isAuthenticated: (leaveEntitlement.leaveEntitlementList.isAuthenticated
      || leaveEntitlement.leaveEntitlementGet.isAuthenticated
      || leaveEntitlement.leaveEntitlementEdit.isAuthenticated
      || leaveEntitlement.leaveEntitlementCreate.isAuthenticated
      || leaveEntitlement.leaveEntitlementDelete.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/leave-entitlement/leave-entitlement-selector.js